import { ProductEnvironment } from '@atlassian/forge-ui';
import { useEnvironment as useJiraEnvironment } from '@atlassian/jira-tenant-context-controller/src/components/environment/index.tsx';

export const useEnvironment = (): ProductEnvironment => {
	const env = useJiraEnvironment();
	switch (env) {
		case 'staging':
			return ProductEnvironment.STAGING;
		case 'dev':
		case 'local':
			return ProductEnvironment.DEVELOPMENT;
		case 'prod':
		default: // fallback to `prod` just like `useEnvironment` does
			return ProductEnvironment.PRODUCTION;
	}
};
